import { type Tone } from '@/domain';
import styles from './StatusDot.module.css';

export function StatusDot({ tone, children }: { tone: Tone; children: string }) {
  return (
    <span className={`${styles.status} ${styles[tone]}`}>
      <span className={styles.dot} />
      {children}
    </span>
  );
}

export function HoldNote({ children }: { children: string }) {
  return <span className={styles.holdNote}>{children}</span>;
}

/**
 * A status with a quieter line under it: a deletion waiting for approval on a
 * case that otherwise reads as usual. Graphite, because red means urgent.
 */
export function StatusWithNote({
  tone,
  children,
  note,
}: {
  tone: Tone;
  children: string;
  note: string | null;
}) {
  return (
    <span className={styles.stack}>
      <StatusDot tone={tone}>{children}</StatusDot>
      {note !== null && <span className={styles.stackNote}>{note}</span>}
    </span>
  );
}

